import { isBoolean } from '@wistia/type-guards';
import { useWindowSize } from '../useWindowSize';
import { breakpoints } from '../../css/breakpoints';

export type UseMqReturnType = {
  isXlAndUp: boolean;
  isLgAndUp: boolean;
  isMdAndUp: boolean;
  isSmAndUp: boolean;
  isXsAndUp: boolean;
  isXsAndDown: boolean;
  isSmAndDown: boolean;
  isMdAndDown: boolean;
  isLgAndDown: boolean;
  isXlAndDown: boolean;
};

const REM_SIZE = 16;

export const useMq = (): UseMqReturnType => {
  const { width } = useWindowSize();
  const viewportWidth = width / REM_SIZE;
  const isXsAndUp = true;
  const isSmAndUp = viewportWidth >= Number.parseFloat(breakpoints.sm);
  const isMdAndUp = viewportWidth >= Number.parseFloat(breakpoints.md);
  const isLgAndUp = viewportWidth >= Number.parseFloat(breakpoints.lg);
  const isXlAndUp = viewportWidth >= Number.parseFloat(breakpoints.xl);

  const isXsAndDown = viewportWidth < Number.parseFloat(breakpoints.sm);
  const isSmAndDown = viewportWidth < Number.parseFloat(breakpoints.md);
  const isMdAndDown = viewportWidth < Number.parseFloat(breakpoints.lg);
  const isLgAndDown = viewportWidth < Number.parseFloat(breakpoints.xl);
  const isXlAndDown = true;

  return {
    isXlAndUp,
    isLgAndUp,
    isMdAndUp,
    isSmAndUp,
    isXsAndUp,
    isXsAndDown,
    isSmAndDown,
    isMdAndDown,
    isLgAndDown,
    isXlAndDown,
  };
};

export type UseActiveMqReturnType = keyof UseMqReturnType;

// Returns an array of the currently active media queries
export const useActiveMq = (): UseActiveMqReturnType[] => {
  const mq: UseMqReturnType = useMq();
  const keys = Object.keys(mq) as UseActiveMqReturnType[];
  return keys.filter((key) => {
    const value = mq[key];
    return isBoolean(value) && value;
  });
};
